import { Component } from '@angular/core';
import { IndexDataComponent } from '../index-data/index-data.component';

@Component({
    selector: 'app-index-descriptions',
    templateUrl: './index-descriptions.component.html',
    styleUrls: ['./index-descriptions.component.scss'],
    imports: [IndexDataComponent]
})
export class IndexDescriptionsComponent {

}
